export default "__VITE_ASSET__a4489925__"